<ion-content class="logsheet">
    <ng-container>
        <app-header [title]="'Logsheet'"  [breadcrumbs]="breadcrumbs"></app-header>
        <ion-grid style="padding-top:120px">
             <div class="loading-container" style="padding-top:10%" *ngIf="!loaded">
                            <ion-spinner></ion-spinner>
                        </div>
            <ion-row class="table-row" style="margin-top:1px">
                <ion-col class="ion-no-padding">
                    <ion-row class="checkbox-row" style="margin:auto; width:96%;" >
                        <ion-col >
                            <div class="route-detail" style="justify-content:left">
                                <span><b><b>Route:</b> {{requestParams.filters.RouteCode}} <b>For:</b> {{currentDate ? (currentDate | date:'shortDate') : ''}}  <b>Wk:</b> {{currentWeek}} <b>Day:</b> {{currentDay}}</b></span>
                            </div>
                        </ion-col>
                        <ion-col>
                            <div class="toggle-button">
                                <ion-checkbox (ionChange)="showAllToggle()" [(ngModel)]="showAllStops" slot="start"></ion-checkbox>
                                <span>Show All Stops</span>
                            </div>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <div *ngIf="loaded">
                            <ion-col>
                                <app-logsheet-table [rows]="routeStops" [currentRoute]="currentNavRoute"></app-logsheet-table>
                            </ion-col>
                        </div>
                       
                    </ion-row>
                </ion-col>
            </ion-row>
        </ion-grid>
    </ng-container>
</ion-content>